import {Base} from "@/api/Base"

export class LeaveEdit extends Base {
    path = "leave/edit"
}